import 'metismenu';
import toastr from 'toastr';
import beautify from './beautify';
// import beautify from './beautify';
var Swal = require('sweetalert2/dist/sweetalert2.js');


/**
 * Serialize A Form To JSON
 */
$.fn.serializeJSON = function () {
    var o = {};
    var a = this.find('input, select, textarea').serializeArray();
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};


$.fn.loadEvents = function () {
    let $elem = this;
        // Ensure "Live" indicator exists
    if ($("#live-indicator").length === 0) {
        let liveHtml = `
            <div id="live-indicator" class="vertical-timeline-item vertical-timeline-element">
                <div>
                    <span
                        class="vertical-timeline-element-icon"
                        data-toggle="tooltip"
                        title="Live">
                        <i style="left:2px; top:2px" class="live-dot"></i>
                    </span>

                    <div class="vertical-timeline-element-content">
                        <h4 class="timeline-title event-title mb-1">
                            <span class="text-success fw-bold">Live Updates</span>
                        </h4>
                    </div>
                </div>
            </div>
        `;
        $elem.prepend(liveHtml);
    }

    let liveOrderEventsUrl = url + '/api/live-order-events';
    $.ajax({
        url: liveOrderEventsUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            if (response && response.length > 0) {
                $.each(response.reverse(), function (index, event) {
                    let eventId = `event-${event.id}`;
                    if ($("#" + eventId).length) return;
                    let badgeType = event.type === 'private' ? 'danger' : 'success';
                    if(!event.order) return;
                    let eventHtml = `
                        <div id="${eventId}" class="vertical-timeline-item vertical-timeline-element">
                            <div>
                                <span
                                    class="vertical-timeline-element-icon bounce-in"
                                    data-toggle="tooltip"
                                    title="${event.type}">
                                    <i class="badge badge-dot badge-dot-xl badge-${badgeType}"></i>
                                </span>

                                <div class="vertical-timeline-element-content bounce-in">
                                    <h4 class="timeline-title event-title">
                                        <a href="${url}/admin/orders/view/${event.order.uuid}" class="text-primary">
                                            #${event.order.reference}
                                        </a> •
                                        ${event.message}
                                    </h4>
                                    <p>
                                        <small class="text-muted event-created-at">${ beautify.date_time(event.created_at) }</small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    `;
                    $("#live-indicator").after(eventHtml);
                    $(`#${eventId} [data-toggle='tooltip']`).tooltip();
                });
            }
        },
        error: function () {
            beautify.notification("Failed to load live order events.", 'error');
        }
    });
};

$.fn.checkNotification = function () {
    const $button = this; // The notifications button

    // Get the API URL from data attribute
    const apiUrl = $button.data('url');

    if (!apiUrl) {
        console.error('No data-url found on the element.');
        return;
    }

    // Make AJAX request
    $.get(apiUrl, function (response) {
        if (response.status === 'success') {
            const count = response.message;

            const $iconWrapper = $button.find('.icon-wrapper');
            const $iconBg = $button.find('.icon-wrapper-bg');
            const $icon = $button.find('i.fas.fa-bell');
            const $badge = $button.find('.badge');
            const $footerNotificationMenu = $('.mm-frontend-notifications-index');
            const $alartImage = $footerNotificationMenu.find('img').attr('alart-src');
            const $normalImage = $footerNotificationMenu.find('img').attr('src');
            if (count === 0) {
                // Change all -danger classes to -primary
                $iconWrapper.removeClass('icon-wrapper-alt').addClass('icon-wrapper-alt'); // optional if needed
                $iconBg.removeClass('bg-danger').addClass('bg-primary');
                $icon.removeClass('text-danger').addClass('text-primary');
                $badge.removeClass('badge-danger').addClass('badge-primary');
                $footerNotificationMenu.find('img').attr('src', $normalImage);
            } else {
                // Change back to -danger
                $iconBg.removeClass('bg-primary').addClass('bg-danger');
                $icon.removeClass('text-primary').addClass('text-danger');
                $badge.removeClass('badge-primary').addClass('badge-danger');
                $footerNotificationMenu.find('img').attr('src', $alartImage);
            }
        } else {
            console.error('Failed to fetch notifications:', response);
        }
    }, 'json')
    .fail(function (err) {
        console.error('AJAX error fetching notifications:', err);
    });

    return this; // To allow chaining
};


$(function() {
    $(document).on('keydown', '.prevent',function (e) {
        var charCode = (e.which) ? e.which : e.keyCode;
        if (charCode == 13) {
            e.preventDefault();
            return false;
        }
    });

    /**
     * Allow only number & Decimal
     */
    $(document).on('keypress', '.decimal, .float, .double, .percentage',function (event) {
        return isNumber(this, event)
    });

    function isNumber(elem, evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;

        if (charCode == 13) return true;

        if (charCode == 45) {
            if (elem.value.indexOf('-') === -1) return true;
            return false;
        }

        if (elem.value.indexOf('%') !== -1){
            if((elem.value.length - elem.value.indexOf('%')) > 1) return false;
        }

        if (charCode == 37) {
            if (elem.value.indexOf('%') === -1) return true;
            return false;
        }
        if (charCode == 46) {
          if (elem.value.indexOf('.') === -1) {
            return true;
          } else {
            return false;
          }
        } else {
          if (charCode > 31 &&
            (charCode < 48 || charCode > 57))
            return false;
        }
        return true;
    }

    // Sidebar Menu
    setTimeout(function () {
        $(".vertical-nav-menu").metisMenu();
    }, 1000);

    $('.dropdown-menu').on('click', function (event) {
        var events = $._data(document, 'events') || {};
        events = events.click || [];
        if($(event.target).attr('data-dismiss') === 'dropdown') return true
        for (var i = 0; i < events.length; i++) {
            if (events[i].selector) {

                if ($(event.target).is(events[i].selector)) {
                    events[i].handler.call(event.target, event);
                }

                $(event.target).parents(events[i].selector).each(function () {
                    events[i].handler.call(this, event);
                });
            }
        }
        event.stopPropagation(); //Always stop propagation
    });


	$('.stopPropagation').on('click', function(e){
		e.stopPropagation();
	})

    $(function () {

        $(document).on('click', '.copy-text', function (e) {
            e.preventDefault();
            var targetSelector = $(this);
            var textToCopy = $(targetSelector).text().trim();
            var originalHtml = $(this).html();
            navigator.clipboard.writeText(textToCopy).then(() => {
                $(this).html('<i class="fas fa-check-circle"></i> Copied...').addClass('highlight');
            }).catch(err => {
                $(this).html("<i class='fas fa-times-circle'></i> Can't copy").addClass('highlight');
            });
            var self = $(this);
            setTimeout(function () {
                self.html(originalHtml);
            }, 1000);
        });

    });

    $('.mobile-toggle-nav').on('click', function () {
        $(this).toggleClass('is-active');
        $('.app-container').toggleClass('sidebar-mobile-open');
    });

    $('.mobile-toggle-header-nav').on('click', function () {
        $(this).toggleClass('active');
        $('.app-header__content').toggleClass('header-mobile-open');
    });



    // Responsive
    var resizeClass = function () {
        var win = document.body.clientWidth;
        if (win < 1250) {
            $('.app-container').addClass('closed-sidebar-mobile closed-sidebar');
        } else {
            $('.app-container').removeClass('closed-sidebar-mobile closed-sidebar');
        }
    };
    // console.log("App Started...")

    $(window).on('resize', function () {
        resizeClass();
    });

    resizeClass();

    initEasyAjax();
    function initEasyAjax(){
        $('.ajax').easyajax({
            before_ajax: function(elem){
                // var str_loading = beautify.loading('Updating...');
                var str_loading = 'Updating...';
                $(elem).find(":submit").html(str_loading);
            },
            after_ajax: function(elem, response){
                if(response.dynamic_reload){
                    if(response.dynamic_reload == 'modal'){
                        // if response have [refresh => modal] -> reload ajaxModal;
                        beautify.ajaxModal(false, $('#myModal').attr('data-source'))
                    }
                }
            },
            error_ajax: function(elem, xhr){
                console.log('Error ajax: from functions.js')
                // if(xhr.status == 422){
                    let err = xhr.responseJSON;
                    if(err.message){
                        toastr.options = {
                            "debug": false,
                            "newestOnTop": true,
                            "progressBar": true,
                            "positionClass": "toast-bottom-right",
                            "preventDuplicates": false,
                            "onclick": null,
                            "showDuration": "300",
                            "hideDuration": "1000",
                            "timeOut": "5000",
                            "extendedTimeOut": "1000",
                            "showEasing": "swing",
                            "hideEasing": "linear",
                            "showMethod": "fadeIn",
                            "hideMethod": "fadeOut"
                        };
                        var errorMessage = err.message ? err.message : 'Oops! Something went wrong. Please try again.';
                        toastr['error'](errorMessage);
                    }
                    $.each(err.errors, function(key, value){
                        if(key.startsWith('#')){
                            $(elem).find(key).attr('data-original-title', value[0]);
                            $(elem).find(key).removeClass('is-valid').addClass('is-invalid').tooltip({
                                template: '<div class="tooltip"><div class="tooltip-inner bg-danger"></div></div>',
                                placement: 'left'
                            })
                            $(elem).find(key).find('.batch').removeClass('is-valid').addClass('is-invalid')

                            return true;
                        }

                        if(key.includes(".")){
                            // Show error for indexed inputs
                            key = key.split(".");
                            var name_index = key[1];
                            key = key[0]
                            value[0] = value[0].replace('.'+name_index, '');

                            $(elem).find('[name="'+key+'[]"]').eq(name_index).removeClass('is-valid').addClass('is-invalid');
                            $(elem).find('[name="'+key+'[]"]').eq(name_index).closest('div').find('.error').text(value[0]);
                        }

                        $(elem).find($("[name='"+key+"']")).removeClass('is-valid').addClass('is-invalid');
                        $(elem).find($("[name='"+key+"']")).closest('div').find('.error').text(value[0]);

                    });
                // }
            },
            after_render: function(elem, response){

            },
            notification: function(data){
                if(data.message){
                    toastr.options = {
                        "debug": false,
                        "newestOnTop": true,
                        "progressBar": true,
                        "positionClass": "toast-bottom-right",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    };
                    toastr[data.status](data.message);
                }
            },
            ajax_form: '.ajax',
            ajax_link: '.ajax',
            csrf_token: $('meta[name="csrf-token"]').attr('content')
        });
    }


    // ----------------------- //
    // -------AJAX CONFIRM-----//

    $(document).on('click', '[data-toggle="ajax-modal"]', function (e) {
        e.preventDefault();
        if($(this).data('confirm')){
            var _elem = $(this)
            beautify.sweetConfirm($(this).data('confirm'), 'Click ok if you want to proceed', function(confirm){
                if(confirm) beautify.ajaxModal(_elem);
            })
        }else{
            beautify.ajaxModal($(this));
        }

        return false;
    });


    // set today date in datepicker class today
    let today = new Date();
    // today = moment(today).format("YYYY-MM-DD");
    $('.today').val(today);

    // select all text of input on click
    $(document).on('click', '.select', function(){
        $(this).trigger('select');
    });

    // show or hide pass
    $('.show_password').on('mousedown', function(e){
        e.preventDefault();
        $('#password').attr('type', function(index, attr){
            return attr == 'password' ? 'text' : 'password';
        });
    }).on('mouseup', function(e){
        e.preventDefault();
        $('#password').attr('type', function(index, attr){
            return attr == 'text' ? 'password' : 'text';
        });
    });


    /**
     * Select2
     */
    $('.select2').select2({
        theme: "bootstrap4",
        width: '100%'
    });

    $('.select2-tag').select2({
        theme: "bootstrap4",
        width: '100%',
        tags: true,
    });


    /**
     * Live Order Events
     */
    if ($('#live-order-events').length) {
        // Initial load
        $('#live-order-events').loadEvents();

        // Refresh every 5 seconds
        setInterval(function () {
            $('#live-order-events').loadEvents();
        }, 5000);
    }

    $("#fetch_notifications").on('click', function(e){
        let dataUrl = $(this).data('url');
        $.ajax({
            url: dataUrl,
            method: 'GET',
            dataType: 'json',
            success: function(response){
                $('.notification-message').text(response.message);
                let notifications = '';

                if(response.data.length){
                    // format notifications
                }else{
                    notifications = '<p class="text-muted text-center my-3">No notifications available</p>';
                }

                $('#admin-notifications').html(notifications);
            }
        });
    })


    if($('.notifications-button').length){

        $('.notifications-button').checkNotification();
        // Optional: poll every 30 seconds
        setInterval(() => {
            $('.notifications-button').checkNotification();
        }, 15000);
    }

});

